import { revenueTypes } from "@/store/types/store-types.js";
import api from "@/api";

const state = {
  revenuePaymentList: [],
  revenueReceiveList: {}
};
const getters = {
  [revenueTypes.getters.getPaymentRevenueList]: state =>
    state.revenuePaymentList,
  [revenueTypes.getters.getReceiveRevenueList]: state =>
    state.revenueReceiveList
};
const mutations = {
  [revenueTypes.mutations.SET_PAYMENT_REVENUE]: (state, payment) =>
    (state.revenuePaymentList = payment),
  [revenueTypes.mutations.SET_RECEIVE_REVENUE]: (state, receive) =>
    (state.revenueReceiveList = receive)
};

const actions = {
  [revenueTypes.actions.QUERY_PAYMENT_REVENUE]: ({ commit }, date) => {
    return api.getPaymentRevenue(date).then(data => {
      commit(revenueTypes.mutations.SET_PAYMENT_REVENUE, data);
    });
  },
  [revenueTypes.actions.QUERY_RECEIVE_REVENUE]: ({ commit }, date) => {
    return api.getReceiveRevenue(date).then(data => {
      commit(revenueTypes.mutations.SET_RECEIVE_REVENUE, data);
    });
  },
  [revenueTypes.actions.ADD_PAYMENT_REVENUE]: (_, payment) => {
    return api.addPaymentRevenue(payment).then(res => {
      return res.data.expenditure_id;
    });
  },
  [revenueTypes.actions.EDIT_PAYMENT_REVENUE]: (_, data) => {
    const id = data.id;
    delete data.id;
    delete data.booked_at;
    return api.editPaymentRevenue(data, id).then();
  },
  [revenueTypes.actions.DELETE_PAYMENT_REVENUE]: ({ commit }, id) => {
    return api.deletePaymentRevenue(id).then(() => {
      commit(revenueTypes.mutations.SET_PAYMENT_REVENUE);
    });
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
